export default __webpack_public_path__ + "static/media/success.df1f2853.svg";